module.exports = require("core-js-pure/stable/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js
// module id = 608
// module chunks = 0